import {
  BookOpenText,
  Box,
  GraduationCap,
  Download,
  FileText,
  FolderKanban,
  Grid2x2,
  Lightbulb,
  Mail,
  MailCheck,
  MapPinned,
  PenSquare,
  PhoneCall,
  BriefcaseBusiness,
  Users,
} from "lucide-react";

export const DEFAULT_CONTENT_PAGE = "home";
export const DEFAULT_PRODUCT_TYPE = "boards";

/** Sidebar items — `segment` matches the URL path under `/dashboard` */
export const getDashboardNavItems = (t) => [
  { id: "overview", segment: "overview", to: "/dashboard/overview", label: t("dashboard.overview"), icon: Grid2x2 },
  {
    id: "content",
    segment: "content",
    to: `/dashboard/content/${DEFAULT_CONTENT_PAGE}`,
    label: t("dashboard.content"),
    icon: FileText,
  },
  {
    id: "products",
    segment: "products",
    to: `/dashboard/products/${DEFAULT_PRODUCT_TYPE}`,
    label: "Products",
    icon: Box,
  },
  { id: "projects", segment: "projects", to: "/dashboard/projects", label: "Projects", icon: FolderKanban },
  { id: "solutions", segment: "solutions", to: "/dashboard/solutions", label: "Solutions", icon: Lightbulb },
  { id: "sectors", segment: "sectors", to: "/dashboard/sectors", label: "Sectors", icon: MapPinned },
  { id: "careers", segment: "careers", to: "/dashboard/careers", label: "Careers", icon: BriefcaseBusiness },
  { id: "courses", segment: "courses", to: "/dashboard/courses", label: "Courses", icon: BookOpenText },
  { id: "trainings", segment: "trainings", to: "/dashboard/trainings", label: "Trainings", icon: GraduationCap },
  { id: "downloads", segment: "downloads", to: "/dashboard/downloads", label: "Downloads", icon: Download },
  {
    id: "calls-requested",
    segment: "calls-requested",
    to: "/dashboard/calls-requested",
    label: "Calls Requested",
    icon: PhoneCall,
  },
  { id: "contact-us", segment: "contact-us", to: "/dashboard/contact-us", label: "Contact Us", icon: Mail },
  { id: "subscribers", segment: "subscribers", to: "/dashboard/subscribers", label: "Subscribed", icon: MailCheck },
  { id: "users", segment: "users", to: "/dashboard/users", label: t("dashboard.users"), icon: Users },
  { id: "blog", segment: "blog", to: "/dashboard/blog", label: "Blog", icon: PenSquare },
];

export const isDashboardNavActive = (pathname, item) => {
  const base = `/dashboard/${item.segment}`;
  return pathname === base || pathname.startsWith(`${base}/`);
};

export const CONTENT_PAGES = [
  { key: "home", label: "Home" },
  { key: "about", label: "About Us" },
  { key: "products", label: "Products" },
  { key: "allsolutions", label: "Solutions" },
  { key: "careers", label: "Careers" },
  { key: "services", label: "Services" },
  { key: "sectors", label: "Sectors" },
  { key: "projects", label: "All Projects" },
  { key: "estimator", label: "Estimator" },
  { key: "blog", label: "Blog" },
  { key: "downloads", label: "Downloads" },
  { key: "academy", label: "Academy" },
  { key: "contactus", label: "Contact" },
  { key: "terms", label: "Terms" },
  { key: "shared", label: "Footer" },
];

export const PRODUCT_TYPES = [
  "boards",
  "accessories",
  "drywall-metal-frame",
  "ceiling-metal-frame",
];
